import { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { findCurrentlyEditedDoc } from 'lib/documentHandling';
import { propOr } from 'ramda';

class DocumentProvider extends Component {
  componentDidUpdate(prevProps) {
    const prevEditDocId = propOr(null, 'documentId', findCurrentlyEditedDoc(prevProps.documents));
    const currEditDocId = propOr(null, 'documentId', findCurrentlyEditedDoc(this.props.documents));

    if (prevEditDocId !== currEditDocId) {
      // Scroll automatically to the top when changing from historyview to editing and back
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { names, documents, isLoading, children, editingDocumentType } = this.props;
    const editingDocsByType = editingDocumentType
      ? documents.filter(d => d.documentType === editingDocumentType)
      : documents;
    const currentlyEditing = findCurrentlyEditedDoc(editingDocsByType);
    return cloneElement(children, {
      editingDocument: currentlyEditing,
      names,
      documents,
      isLoading,
    });
  }
}

DocumentProvider.propTypes = {
  children: PropTypes.element.isRequired,
  names: PropTypes.array,
  documents: PropTypes.array,
  isLoading: PropTypes.bool,
  // If set, the provider should only consider this document type when determining if theres a document being edited
  editingDocumentType: PropTypes.string,
};

export default DocumentProvider;
